import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import CkEditor from "../../../Components/CkEditor";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCampaignDetailState, getCampaignDetail as onGetCampaignDetails, addNewCampaignDetail as onAddNewCampaignDetail, updateCampaignDetail as onUpdateCampaignDetail, deleteCampaignDetail as onDeleteCampaignDetail, getCampaignDetailLoading } from "../../../store/campaignDetail/action";
import { getCampaign as onGetCampaigns, addNewCampaign as onAddNewCampaign, updateCampaign as onUpdateCampaign, deleteCampaign as onDeleteCampaign, getCampaignLoading, resetCampaignState } from "../../../store/campaign/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { resetAgentState, getAgent, } from "../../../store/agent/action";

import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";

const typeSelectData = [
  {
    options: [
      { label: "PriceList", value: "PriceList" },
      { label: "Banner", value: "Banner" },
      { label: "Produk", value: "Produk" },
      { label: "Video", value: "Video" },
      { label: "Review", value: "Review" },
      { label: "Promo", value: "Promo" },
    ],
  },
];

const Campaign = () => {
  const [pIndexSecond, setPIndexSecond] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { campaigns, isCampaignCreated, isCampaignSuccess, loading, error, campaignDetails, campaignDetailLoading, isCampaignDetailCreated, isCampaignDetailSuccess, agents, agentLoading, companies, companyLoading, clientLoading, clients } = useSelector((state) => ({
    campaigns: state.Campaign.campaigns,
    isCampaignCreated: state.Campaign.isCampaignCreated,
    isCampaignSuccess: state.Campaign.isCampaignSuccess,
    loading: state.Campaign.loading,
    error: state.Campaign.error,
    campaignDetails: state.CampaignDetail.campaignDetails,
    campaignDetailLoading: state.CampaignDetail.loading,
    isCampaignDetailCreated: state.CampaignDetail.isCampaignDetailCreated,
    isCampaignDetailSuccess: state.CampaignDetail.isCampaignDetailSuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    agents: state.Agent.agents,
    agentLoading: state.Agent.loading,
  }));

  const [logo, setLogo] = useState(defaultImg);
  const [isSearch, setIsSearch] = useState(false);
  const [campaignList, setCampaignList] = useState([]);
  const [campaign, setCampaign] = useState([]);
  const [optionDetailAddedId, setCampaignDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [campaignDetail, setCampaignDetail] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [detailList, setDetailList] = useState([])
  const [searchValueSecond, setSearchValueSecond] = useState([]);
  const [campaignDetailFiles, setCampaignDetailFiles] = useState([]);
  const [campaignFiles, setCampaignFiles] = useState([]);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);


  const onClickDelete = (campaign) => {
    setCampaign(campaign);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (campaignDetail) => {
    setCampaignDetail(campaignDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteCampaign = () => {
    if (campaign) {
      dispatch(onDeleteCampaign(campaign));
      setDeleteModal(false);
    }
  };

  const handleDeleteCampaignDetail = () => {
    if (campaignDetail) {
      setCampaignDetailAddedId(campaignDetail.optionId);
      dispatch(onDeleteCampaignDetail(campaignDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setCampaign(employee);
    setApproveModal(true);
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredCampaigns = campaigns;
      if (type !== "all") {
        filteredCampaigns = campaigns.filter((campaign) => campaign.campaign_status.name === type);
      }
      setCampaignList(filteredCampaigns);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });

        dispatch(onGetCampaigns());
        dispatch(resetClientState());
        dispatch(getClient());
        dispatch(resetAgentState());
        dispatch(getAgent());
        handleGetCompany(obj.data.clientId);
      }
    }
  }, [dispatch, isSearch]);

  useEffect(() => {
    if (!isEmpty(campaigns)) {
      setIsEdit(false);
      setCampaignList(campaigns);
      let current = 0;
      if (optionDetailAddedId !== 0) {
        campaigns.forEach((obj, i) => {
          if (obj.id === optionDetailAddedId) current = i;
        });
      }
      setInfo(campaigns[current]);
    }
  }, [campaigns, optionDetailAddedId]);

  useEffect(() => {
    if (isCampaignDetailCreated) {
      dispatch(resetCampaignDetailState());
      dispatch(resetCampaignState());
      dispatch(onGetCampaigns());
    }
  }, [dispatch, isCampaignDetailCreated]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCampaign(null);
      setCampaignFiles([]);
      setCompanyList([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleCampaignClick = useCallback((data) => {
    let files = [];
    for (const f of data.campaign_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setCampaignFiles(files);

    setCampaign({
      id: data.id,
      name: data.name,
      isColor: data.isColor,
      client: data.campaign_client === null ? "" : { label: data.campaign_client ? data.campaign_client.name : "", value: data.campaign_client ? data.campaign_client.id : "" },
      company: data.campaign_company === null ? "" : { label: data.campaign_company ? data.campaign_company.name : "", value: data.campaign_company ? data.campaign_company.id : "" },
    });

    setIsEdit(true);
    toggle();
  }, [toggle, userType]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setCampaignDetail(null);
      setCampaignDetailFiles([]);
      setCampaign(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleCampaignDetailClick = useCallback((data, isEdit) => {

    let arrFile = [];
    for (const f of data.campaign_detail_file) {
      arrFile.push({ filename: f.filename })
    }
    setCampaignDetailFiles(arrFile);

    setCampaignDetail({
      id: data.id,
      image: data.image,
      statusId: data.statusId,
      title: data.title,
      type:
        data.type && {
          label: data.type,
          value: data.type,
        },
      price: data.price,
      category: data.category,
      publishedat: data.publishedat,
      description: data.description,
      meta_keyword: data.meta_keyword,
      sort_order: data.sort_order,
      meta_description: data.meta_description,
      company:
        data.data_company && {
          label: data.data_company.name,
          value: data.data_company.id,
        },
      client:
        data.data_client && {
          label: data.data_client.name,
          value: data.data_client.id,
        },
      branch:
        data.data_branch && {
          label: data.data_branch.name,
          value: data.data_branch.id,
        },
    });
    setIsEditDetail(isEdit);
    toggleDetail();
  }, [toggleDetail]);

  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light" className="btn-sm" onClick={() => {
                  setInfo(data);
                }}><i className="ri-eye-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  handleCampaignClick(data);
                }}><i className="ri-edit-2-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  onClickDelete(data);
                }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
            {cellProps.row.original.statusId === 1 && (
              <button
                className="btn-label btn btn-sm btn-soft-success fs-12 ms-2"
                onClick={() => {
                  onClickApprove(data);
                }}>
                <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
              </button>
            )}
          </div>
        );
      },
    },
    {
      Header: "Campaign",
      accessor: "name",
      filterable: true,
    },
    {
      Header: "Status",
      accessor: "campaign_status.name",
      filterable: true,
      Cell: (cell) => {
        switch (cell.value) {
          case "DRAFT":
            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          case "ACTIVE":
            return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
          case "INACTIVE":
            return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
          default:
            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
        }
      },
    }], [handleCampaignClick]);

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: campaignList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(() => [
    {
      id: "#",
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light" className="btn-sm" onClick={() => {
                  handleCampaignDetailClick(data, true);
                }}><i className="ri-edit-2-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  onClickDeleteDetail(data);
                }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
          </div>
        );
      },
    },
    {
      id: "Image",
      Header: "Image",
      accessor: "title",
      filterable: true,
      Cell: (cell) => {
        let data = cell.row.original;
        let stat;
        let statName = data.campaign_detail_status && data.campaign_detail_status.name
        switch (statName) {
          case "DRAFT":
            stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
            break;
          case "ACTIVE":
            stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
            break;
          default:
            stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
            break;
        }
        let type = checkType(data.type).label
        const img = data.image === "" ? logo : `${api.MEDIA_URL}/media/${data.image}-w-100`;
        return (
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-3">
              <img src={img} alt="defaultImg" className="avatar-md rounded-circle object-cover" />
            </div>
            <div className="flex-grow-1 align-items-center">
              <h5 className="fs-14 mb-1">
                {data.title}
              </h5>
              <p>{stat} - {handleValidDate(data.publishedat)}</p>
            </div>
          </div>
        );
      },
    },
    {
      id: "Category",
      Header: "Category",
      accessor: "category",
      filterable: true,
    },
    {
      id: "Type",
      Header: "Type",
      accessor: "type",
      filterable: true,
    },
    {
      id: "Publish",
      Header: "Tanggal Publish",
      accessor: "publishedat",
      filterable: true,
      Cell: (data) => <>{handleValidDate(data.row.original.publishedat)},</>,
    },
    {
      id: "Status",
      Header: "Status",
      accessor: "campaign_detail_status.name",
      filterable: true,
    }], [info]);


  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Publish"],
        pageIndex: pIndexSecond,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  const handleApproveCampaign = () => {
    if (campaign) {
      campaign.setApprove = true;
      dispatch(onUpdateCampaign(campaign));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (campaign && campaign.name) ?? "",
      isColor: (campaign && campaign.isColor) || false,
      client: (campaign && campaign.client) || clientSelected,
      company: (campaign && campaign.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Product Name"),
    }),
    onSubmit: (values) => {
      dispatch(getCampaignLoading());
      if (isEdit) {
        const updateCampaign = {
          id: campaign ? campaign.id : 0,
          name: values.name,
          isColor: values.isColor,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdateCampaign(updateCampaign));
        validation.resetForm();
      } else {
        const newCampaign = {
          name: values.name,
          isColor: values.isColor,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewCampaign(newCampaign));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      image: (campaignDetail && campaignDetail.image) ?? "",
      status: (campaignDetail && campaignDetail.status) ?? "",
      title: (campaignDetail && campaignDetail.title) ?? "",
      type: (campaignDetail && campaignDetail.type) ?? "",
      category: (campaignDetail && campaignDetail.category) ?? "",
      price: (campaignDetail && campaignDetail.price) ?? "",
      publishedat: (campaignDetail && campaignDetail.publishedat) ?? "",
      description: (campaignDetail && campaignDetail.description) ?? "",
      meta_keyword: (campaignDetail && campaignDetail.meta_keyword) ?? "",
      meta_description: (campaignDetail && campaignDetail.meta_description) ?? "",
      branch: (campaignDetail && campaignDetail.branch) ?? "",
      client: (campaignDetail && campaignDetail.client) || clientSelected,
      company: (campaignDetail && campaignDetail.company) || companySelected,
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Title"),
      publishedat: Yup.string().required("Please Enter Tanggal"),
      type: Yup.object().required("Please Enter Type"),
    }),
    onSubmit: (values) => {
      if (info.id) {
        if (isEditDetail) {
          let dataEdit = {
            id: campaignDetail ? campaignDetail.id : 0,
            campaignId: info ? info.id : 0,
            image: values.image,
            statusId: campaignDetail ? campaignDetail.statusId : 1,
            title: values.title,
            type: values.type.value,
            category: values.category,
            price: values.price,
            sort_order: values.sort_order,
            publishedat: values.publishedat,
            description: values.description,
            meta_keyword: values.meta_keyword,
            meta_description: values.meta_description,
            branchId: values.branch.value,
            companyId: values.company.value,
            clientId: values.client.value,
            files: campaignDetailFiles.length > 0 ? campaignDetailFiles : [],
          };

          dispatch(onUpdateCampaignDetail(dataEdit));
        } else {
          let dataAdd = {
            image: values.image,
            campaignId: info ? info.id : 0,
            statusId: 2,
            title: values.title,
            type: values.type.value,
            category: values.category,
            price: values.price,
            sort_order: values.sort_order,
            publishedat: values.publishedat,
            description: values.description,
            meta_keyword: values.meta_keyword,
            meta_description: values.meta_description,
            branchId: values.branch.value,
            companyId: values.company.value,
            clientId: values.client.value,
            files: campaignDetailFiles.length > 0 ? campaignDetailFiles : [],
          };

          dispatch(onAddNewCampaignDetail(dataAdd));
        }
        validationDetail.resetForm();
        toggleDetail();
      }
      else {
        toast.error("Please Choose Campaign", { autoClose: 3000 });
      }
    },
  });

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validationDetail.setFieldValue("image", file.filename);
        break;
      case "files":
        setCampaignDetailFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
      case "imageVarian":
        validation.setFieldValue("imageVarian", file.filename);
        break;
      default:
        setCampaignDetailFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    if (isEditDetail) {
      const newState = campaignDetailFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setCampaignDetailFiles(newState);
    } else {
      const index = campaignDetailFiles.findIndex((fl) => fl.filename === file.filename);
      setCampaignDetailFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCampaignDetail(element.target.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };

    dispatch(onGetCampaigns(param));
  }

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (info && info.campaign_detail) {
      setDetailList(info.campaign_detail)
    }
  }, [info])

  const checkType = (val) => {
    switch (val) {
      case "PriceList":
        return {
          label: "PriceList",
          value: "PriceList",
        };
      case "Banner":
        return {
          label: "Banner",
          value: "Banner",
        };
      case "Produk":
        return {
          label: "Produk",
          value: "Produk",
        };
      case "Video":
        return {
          label: "Video",
          value: "Video",
        };
      case "Review":
        return {
          label: "Review",
          value: "Review",
        };
      case "Promo":
        return {
          label: "Promo",
          value: "Promo",
        };
      default:
        break;
    }
  };

  useEffect(() => {
    setPIndexSecond(pageIndexSecond)
  }, [pageIndexSecond])

  document.title = "Campaigns | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={campaign ? campaign.name : ""} show={approveModal} onApproveClick={handleApproveCampaign} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCampaign} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteCampaignDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Campaigns" pageTitle="Human Resources" />
        <Row>
          <Col sm={5}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Campaign &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCampaign") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                      id="create-btn"
                      onClick={() => {
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} /><i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}><i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-campaignDetail-md-end justify-campaignDetail-center align-items-center p-2">
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}</Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Campaign" : "Add Campaign"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp; {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp; {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Name
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-campaignDetail-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Campaign"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Edit Campaign" : "Add Campaign"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <Row>
                        <Col lg={8}>
                          <div className="mb-3">
                            <Label htmlFor="title-field" className="form-label">
                              Title
                            </Label>
                            <Input name="title" id="title-field" className="form-control" placeholder="Enter Title" type="input" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.title ?? ""} />
                            {validationDetail.touched.title && validationDetail.errors.title ? (
                              <p className="text-danger" type="invalid">
                                {validationDetail.errors.title}
                              </p>
                            ) : null}
                          </div>
                          <Row>
                            <div className="mb-3 col-lg-4">
                              <Label htmlFor="type-field" className="form-label">
                                Type
                              </Label>
                              <Select
                                name="type"
                                value={validationDetail.values.type}
                                placeholder="Select Type"
                                onChange={(e) => {
                                  validationDetail.setFieldValue("type", e);
                                }}
                                options={typeSelectData}
                                invalid={validationDetail.touched.type && validationDetail.errors.type ? true : false}></Select>
                              {validationDetail.touched.type && validationDetail.errors.type ? (
                                <p className="text-danger" type="invalid">
                                  {validationDetail.errors.type}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-8">
                              <Label htmlFor="category-field" className="form-label">
                                Category
                              </Label>
                              <Input name="category" id="category-field" className="form-control" placeholder="Enter Category" type="input" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.category ?? ""} />
                              {validationDetail.touched.category && validationDetail.errors.category ? (
                                <p className="text-danger" type="invalid">
                                  {validationDetail.errors.category}
                                </p>
                              ) : null}
                            </div>
                          </Row>
                          <div className="mb-3">
                            <Label htmlFor="title-field" className="form-label">
                              Content
                            </Label>
                            <CkEditor
                              data={validationDetail.values.description}
                              onReady={(editor) => {
                                editor.editing.view.change((writer) => {
                                  writer.setStyle("height", "500px", editor.editing.view.document.getRoot());
                                });
                              }}
                              onChange={(value) => {
                                validationDetail.setFieldValue("description", value);
                              }} />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp; {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp; {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                          </div>
                          <Row>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Publish
                              </Label>
                              <Flatpickr
                                name="date-picker"
                                className="form-control"
                                placeholder="Select Tanggal Publish"
                                options={{
                                  enableTime: false,
                                  time_24hr: false,
                                  dateFormat: "Y/m/d",
                                }}
                                value={validationDetail.values.publishedat ?? ""}
                                onChange={(o, e) => {
                                  validationDetail.setFieldValue("publishedat", e);
                                }} />
                              {validationDetail.touched.publishedat && validationDetail.errors.publishedat ? (
                                <small className="text-danger mt-1 fs-12" type="invalid">
                                  {validationDetail.errors.publishedat}
                                </small>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="sort_order-field" className="form-label">
                                Sort Order
                              </Label>
                              <Input name="sort_order" id="sort_order-field" className="form-control" placeholder="Input No Urut" type="input" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.sort_order ?? ""} />
                              {validationDetail.touched.sort_order && validationDetail.errors.sort_order ? (
                                <p className="text-danger" type="invalid">
                                  {validationDetail.errors.sort_order}
                                </p>
                              ) : null}
                            </div>
                          </Row>
                          <div className="mb-3">
                            <Label htmlFor="price-field" className="form-label">
                              Price
                            </Label>
                            <Input name="price" id="price-field" className="form-control" placeholder="Enter Price" type="input" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.price ?? ""} />
                            {validationDetail.touched.price && validationDetail.errors.price ? (
                              <p className="text-danger" type="invalid">
                                {validationDetail.errors.price}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="target_url-field" className="form-label">
                              Target URL
                            </Label>
                            <Input name="target_url" id="target_url-field" className="form-control" placeholder="Enter Target URL" type="input" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.target_url ?? ""} />
                            {validationDetail.touched.target_url && validationDetail.errors.target_url ? (
                              <p className="text-danger" type="invalid">
                                {validationDetail.errors.target_url}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="meta_keyword-field" className="form-label">
                              Keyword
                            </Label>
                            <Input name="meta_keyword" id="meta_keyword-field" className="form-control" placeholder="Enter Keyword" type="input" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.meta_keyword ?? ""} />
                            {validationDetail.touched.meta_keyword && validationDetail.errors.meta_keyword ? (
                              <p className="text-danger" type="invalid">
                                {validationDetail.errors.meta_keyword}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="meta_description-field" className="form-label">
                              Meta Description
                            </Label>
                            <Input name="meta_description" id="meta_description-field" className="form-control" placeholder="Enter Keterangan" type="textarea" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.meta_description ?? ""} />
                            {validationDetail.touched.meta_description && validationDetail.errors.meta_description ? (
                              <p className="text-danger" type="invalid">
                                {validationDetail.errors.meta_description}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="image" className="form-label">
                              Image
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}><i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validationDetail.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validationDetail.values.image === "" ? defaultImg : `${api.MEDIA_URL}/media/${validationDetail.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validationDetail.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validationDetail.setFieldValue("image", "");
                                    }}>
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="taskFiles" className="form-label me-3">
                              Campaign Files
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("files");
                                toggleMedia();
                              }}>
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {campaignDetailFiles.map((productFile, i) => {
                            if (productFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={productFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${productFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{productFile.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          handleDeleteFile(productFile);
                                        }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-campaignDetail-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEditDetail ? "Update" : "Add Campaign Detail"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
          <Col sm={7}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className="btn btn-success add-btn"
                    id="create-btn"
                    onClick={() => {
                      setCampaign(info);
                      setIsEditDetail(false);
                      toggleDetail();
                    }}><i className="ri-list-check label-icon align-middle fs-13 me-1"></i>Add Detail
                  </button>
                </div>
              </div>
              <div className="card-body">
                <Row>
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2">
                            <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                              {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                <option key={pageSizeSecond} value={pageSizeSecond}>
                                  {pageSizeSecond}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValueSecond(e.target.value);
                                onChangeSecond(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`Search...`}
                              value={searchValueSecond ?? ""} />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-campaignDetail-md-end justify-campaignDetail-center align-items-center p-2">
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Page
                    <strong>
                      {pageIndexSecond + 1} of {pageOptionsSecond.length}
                    </strong>
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} value={pIndexSecond + 1} onChange={onChangeInInputSecond} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
        <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
      </Container>
    </div>
  );
};

export default Campaign;
